import React, { useState } from "react";
import "./FAQAccordion.css";
const leftFaqs = [
  {
    question: "Chi può diventare un partner di Psicopatici?",
    answer: `
      Chiunque abbia una community, un pubblico o un'attività online può diventare Partner. 
      Se sei un content creator, un influencer, un marketer o gestisci un blog o e-commerce, 
      sei perfettamente adatto al nostro programma.
    `,
  },
  {
    question: "Devo già essere cliente Psicopatici?",
    answer: `
      No, non è necessario. 
      Ma se conosci il brand e ne condividi lo stile, 
      sarà ancora più facile promuoverlo in modo autentico ed efficace.
    `,
  },
  {
    question: "Quali metodi di promozione sono accettati?",
    answer: `
      Social media, blog, newsletter, video, passaparola, QR code in negozio, 
      live streaming e molto altro. L’importante è rispettare le nostre linee guida etiche.
    `,
  },
];
const rightFaqs = [
  {
    question: "Quali azioni generano guadagni?",
    answer: `
      Tutti gli acquisti effettuati tramite il link di tracciamento di un partner oppure gli acquisti effettuati inserendo il codice di riferimento del partner.
    `,
  },
  {
    question: "Come monitoro il mio lavoro e come ricevo il pagamento delle commissioni?",
    answer: `Ogni partner ha a disposizione una dashboard personale dove poter monitorare in tempo reale l’andamento delle proprie vendite, report personalizzati e tutte le informazioni relative alla propria rete. Il pagamento avviene ogni 3 mesi, tramite bonifico bancario, a saldo fattura emessa dal partner di riferimento e caricata all’interno della sua Area Partner.
    `,
  },
  {
    question: "Dove trovo i materiali per promuovere?",
    answer: `
      Una volta approvato, avrai accesso all'area partner con grafiche, banner, 
      codici sconto personalizzati e consigli su come promuovere al meglio Psicopatici.
    `,
  }
];

function FAQAccordion() {
  // Gestione stato per la colonna di sinistra
  const [activeIndexLeft, setActiveIndexLeft] = useState(null);
  // Gestione stato per la colonna di destra
  const [activeIndexRight, setActiveIndexRight] = useState(null);

  const toggleLeft = (index) => {
    setActiveIndexLeft((prevIndex) => (prevIndex === index ? null : index));
  };

  const toggleRight = (index) => {
    setActiveIndexRight((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <div className="faq-container">
      {/* Colonna di sinistra */}
      <div className="faq-column">
        {leftFaqs.map((faq, index) => (
          <div key={index} className="faq-item">
            <div className="faq-question" onClick={() => toggleLeft(index)}>
              <span className="text-black fw-bold" style={{ fontSize: "16px" }}>
                {faq.question}
              </span>
              <span className="faq-symbol">
                {activeIndexLeft === index ? "–" : "+"}
              </span>
            </div>
            <div
              className={`faq-answer ${
                activeIndexLeft === index ? "show" : ""
              }`}
            >
              {faq.answer}
            </div>
          </div>
        ))}
      </div>

      {/* Colonna di destra */}
      <div className="faq-column">
        {rightFaqs.map((faq, index) => (
          <div key={index} className="faq-item">
            <div className="faq-question" onClick={() => toggleRight(index)}>
              <span className="text-black fw-bold" style={{ fontSize: "16px" }}>
                {faq.question}
              </span>
              <span className="faq-symbol">
                {activeIndexRight === index ? "–" : "+"}
              </span>
            </div>
            <div
              className={`faq-answer ${
                activeIndexRight === index ? "show" : ""
              }`}
            >
              {faq.answer}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default FAQAccordion;
